/**
* Created by JMC on 06/11/19.
*/
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AppComponent } from '../app.component';
import { HubService } from '../services/hub.service';
import { IssueCount } from '../types/issue-count';
import { IssueTagCount } from '../types/issues-tag-count'
import { IssueTagTotals } from '../types/issues-tag-totals'

@Component({
  selector: 'issues-stats',
  templateUrl: './issue-stats.component.html',
  styleUrls: ['./issue-stats.component.css'],
})

export class IssueStatsComponent implements OnInit {
  openTagCount: IssueTagCount[] = [];
  closedTagCount: IssueTagCount[] = [];
  closedCounts = new IssueTagTotals();
  openCounts = new IssueTagTotals();
  errorMessage: string;
 
  constructor(
    private hubService: HubService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }

    this.hubService.getIssueTagCounts("open").subscribe(
      tagCount => {
        this.openTagCount = tagCount;
        this.calcTags(this.openTagCount, this.openCounts);
      },
      error => this.errorMessage = <any>error,
    );

    this.hubService.getIssueTagCounts("closed").subscribe(
      tagCount => {
        this.closedTagCount = tagCount;
        this.calcTags(this.closedTagCount, this.closedCounts);
      },
      error => this.errorMessage = <any>error,
    );
  }

  calcTags(tagCount :IssueTagCount[], totals: IssueTagTotals ): void {
    for (let i = 0; i < tagCount.length; i++) {
      switch (tagCount[i].issue_tag_id) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
        case 8:
        case 20:
          totals.generalQuestionsTotal += tagCount[i].num_tags;
          break;
        case 9:
        case 10:
        case 11:
        case 19:
        case 22:
            totals.softwareTotal += tagCount[i].num_tags;
          break;
        case 12:
        case 13:
        case 14:
        case 15:
            totals.hardwareTotal += tagCount[i].num_tags;
          break;
        case 16:
        case 17:
            totals.wifiTotal += tagCount[i].num_tags;
          break;
        case 18:
        case 21:
            totals.installationTotal += tagCount[i].num_tags;
          break;
        default:
            totals.untaggedTotal += tagCount[i].num_tags;

      }
    }
  }

  TotalTotals(total: IssueTagTotals): number{
    var value = 0;
    for (let key in total) {
      value += total[key];
      // Use `key` and `value`
    }
    return value;
  }

  ifEmpty(name: any): string {
    if (name != null)
      return name;
    else
      return "Not Tagged"

  }
}
